import React, { Fragment, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import PresentationContext from './PresentationContext';
import { giveConsent } from './actions/consent';
import ConnectedLogo from './images/ConnectedLogo';
import StopLogo from './images/StopLogo';


const [active, requested, denied, empty] = ['given', 'requested', 'denied', 'empty'];

function getState(instances = []) {
  const lastInstance = instances[instances.length - 1];
  if (!lastInstance) {
    return empty;
  }
  if (lastInstance.denied) {
    return denied;
  }
  if (lastInstance.given) {
    return active;
  }
  return requested;
}

// function Consent({ id, organization, practitioner, instances = [], lastUsed = { date: '2020-03-18T14:11:18+02:00', by: 'Dr. Endo' }}) {
function Consent({ id, organization, practitioner, instances = [] }) {
  const { t } = useTranslation('account');
  const { formatTimeAndDate } = useContext(PresentationContext);
  const reduxDispatch = useDispatch();
  const [busy, setBusy] = useState(false);

  const title = organization || practitioner;
  const state = getState(instances);
  const lastInstance = instances[instances.length - 1];

  const respond = (value) => {
    setBusy(true);
    reduxDispatch(giveConsent({ consentId: id, given: value }))
    .catch(console.error)
    .then(() => {
      setBusy(false);
    });
  };

  if (state === empty) {
    return (
      <Redirect to="/consents" />
    );
  }

  return (
    <div className={`${state} consent`}>
      <h3 className="consent">
        <strong>
          {title
          .replace('/DIAB', '')
          .replace('https://gw.apottiekosysteemi.fi/Interconnect-FHIR-EKO01/api/FHIR/STU3/Organization/490771', 'Apotin ekosysteemi')
          .replace('e2M9MGOmpSK1.4tmwMUYhTLux72erWiTvvLO7awe3kUk3', 'HUS Erikoissairaanhoito')
          }
          {organization && (organization.indexOf('/DIAB') >= 0)
            ? (
              <Fragment>
                <br/>
                DIABETESVASTAANOTTO
              </Fragment>
            )
            : undefined
          }
        </strong>
      </h3>
      <p>{t('consents.purpose.usedFor')}{t('consents.purpose.treatment')}</p>
      <p><small style={{color: 'black'}}><a href="#">Details</a></small></p>
      <div className="last-used description">
        {((instances.length > 1) || ( state !== requested))
        ? (
          <details className="inline">
            <summary>
              {t(`consents.${state}`, { when: formatTimeAndDate(new Date(lastInstance[state])) })}
            </summary>
            {
              <ul>
                {instances.map((instance, i) => (
                  [requested, active, denied].map(s => (
                    ((i > 0 || state !== s) && instance[s])
                    ? (
                      <li key={`${i}-${instance[s]}`}>
                        {t(`consents.${s}`, { when: formatTimeAndDate(new Date(instance[s])) })}
                        <br />
                      </li>
                    )
                    : undefined
                  ))
                ))}
              </ul>
            }
          </details>
        )
        : (
          <p>
            {t(`consents.${state}`, { when: formatTimeAndDate(new Date(lastInstance[state])) })}
          </p>
        )
        }
          {/*
            DO WE WANT THIS?
          lastUsed
          ? (
            <details className="inline">
              <summary>Käytetty viimeksi {formatTimeAndDate(new Date(lastUsed.date))}</summary>
              <ul>
                <li>Haetaan lisätietoja...</li>
              </ul>
            </details>
          )
          : undefined
          */}
        </div>


      {/* overview */}
      {state !== denied
      ? (
        <button
          className="secondary btn warning"
          disabled={busy}
          onClick={() => respond(false)}
        >
          {t('consents.denyPermission')}
        </button>
      )
      : undefined
      }
      {state !== active
      ? (
        <button
          className={`${state !== denied ? 'primary ' : ''}btn`}
          disabled={busy}
          onClick={() => respond(true)}
        >
          {t('consents.givePermission')}
        </button>
      )
      : undefined
      }
      {
        state !== requested && state !== empty
        ? (
          <Fragment>
            <button
              className="secondary btn"
              disabled={busy}
              onClick={f => f}
            >
              {t('consents.inspectUse')}
            </button>
            <button
              className="secondary btn"
              disabled={busy}
              onClick={f => f}
            >
              {t('consents.downloadReceipt')}
            </button>
          </Fragment>
        )
        : undefined
      }
 
      { state === active
      ? <ConnectedLogo />
      : undefined
      }
      { state === denied
      ? <StopLogo />
      : undefined
      }
    </div>
  );
}

export const propTypes = {
  server: PropTypes.string.isRequired,
  organization: PropTypes.string,
  practitioner: PropTypes.string,
  instances: PropTypes.arrayOf(PropTypes.shape({
    requested: PropTypes.string.isRequired,
    given: PropTypes.string,
    denied: PropTypes.string,
  })).isRequired,
};

Consent.propTypes = propTypes;

export default Consent;
